import { JSX } from 'react'

import { IconProps } from '../../icon'

const Unlink: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M18.4413 29.5587C17.6987 28.816 17.1413 27.9493 16.7333 27.024L18.8267 24.9307C19.06 25.9453 19.5573 26.904 20.3267 27.6733C21.2267 28.5733 22.38 29.108 23.6227 29.264L26.1533 31.7947C25.5613 31.9253 24.9533 32 24.3333 32C22.1067 32 20.0147 31.1333 18.4413 29.5587ZM8.05733 9.94267L38.0573 39.9427L39.9427 38.0573L30.8347 28.9493L37.5587 22.2253C39.1333 20.652 40 18.5587 40 16.3333C40 14.108 39.1333 12.0147 37.5587 10.4413C35.9853 8.86667 33.8933 8 31.6667 8C29.44 8 27.348 8.86667 25.7747 10.4413L22.8413 13.3747C23.1147 13.3547 23.3893 13.3347 23.6653 13.3347C24.5733 13.3347 25.46 13.456 26.3187 13.668L27.6587 12.328C28.7293 11.2573 30.152 10.668 31.6653 10.668C33.1787 10.668 34.6013 11.2573 35.672 12.328C36.7427 13.3987 37.332 14.8213 37.332 16.3347C37.332 17.848 36.7427 19.272 35.672 20.3413L28.948 27.0653L21.1453 19.2627C21.928 18.8707 22.7813 18.668 23.6653 18.668C25.1787 18.668 26.6013 19.2573 27.672 20.328C28.4413 21.0973 28.9387 22.056 29.172 23.0707L31.2653 20.9773C30.8573 20.052 30.3 19.184 29.5573 18.4427C27.984 16.868 25.892 16.0013 23.6653 16.0013C22.0533 16.0013 20.512 16.456 19.1867 17.304L9.94267 8.05733L8.05733 9.94267ZM8 31.6667C8 33.892 8.86667 35.9853 10.4413 37.5587C12.0147 39.1333 14.1067 40 16.3333 40C18.56 40 20.652 39.1333 22.2253 37.5587L25.1587 34.6253C24.8853 34.6453 24.6107 34.6653 24.3347 34.6653C23.4267 34.6653 22.54 34.544 21.6813 34.332L20.34 35.6733C19.2693 36.744 17.8467 37.3333 16.3333 37.3333C14.82 37.3333 13.3973 36.744 12.3267 35.6733C11.256 34.6027 10.6667 33.18 10.6667 31.6667C10.6667 30.1533 11.256 28.7293 12.3267 27.66L17.224 22.7627L15.3387 20.8773L10.4413 25.7747C8.86667 27.348 8 29.4413 8 31.6667Z'
      fill='black'
    />
  </svg>
)

export default Unlink
